<template>
  <b-card>
    <div class="d-flex flex-wrap">
      <b-form-group
        label="نوع پیام"
        class="mb-1 col-md-4 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <v-select
          v-model="notificationType"
          item-text="label"
          :options="notificationTypes"
        />
      </b-form-group>
      <b-form-group
        label="وضعیت پیام"
        class="mb-1 col-md-4 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <v-select
          v-model="notificationStatus"
          item-text="label"
          :options="notificationStatuses"
        />
      </b-form-group>
    </div>
    <div class="d-flex flex-wrap align-items-end">
      <b-form-group
        label="سرچ بر اساس "
        class="mb-0 col-md-4 pr-md-1 pr-50 px-0 col-sm-6 col-12 mb-1"
      >
        <v-select
          v-model="searchBy"
          item-text="label"
          :options="searchByType"
          :reduce="(item) => item.value"
        />
      </b-form-group>
      <b-form
        @submit.prevent="onSearch"
        class="d-flex col-md-4 pr-md-1 pr-50 px-0 col-sm-6 col-12 mb-1"
      >
        <b-form-input v-model.trim="search" class="mr-1" />
        <b-button
          variant="primary"
          type="submit"
          :disabled="!search || !searchBy"
        >
          جستجو
        </b-button>
      </b-form>
      <b-button
        variant="outline-primary"
        :to="{ name: 'notification-add' }"
        class="ml-sm-auto mb-1"
      >
        ایجاد پیام
      </b-button>
    </div>

    <data-table :fields="fields" :items="Notifications" :loading="loading">
      <template #admin_notify="{ data }">
        <span>
          {{ data.item.admin_notify || "-" }}
        </span>
      </template>
      <template #user_notify="{ data }">
        <span>
          {{ data.item.user_notify || "-" }}
        </span>
      </template>
      <template #subject="{ data }">
        <span>
          {{ data.item.subject || "-" }}
        </span>
      </template>
      <template #email="{ data }">
        <b-badge variant="light-success" class="ml-25" v-if="data.item.email"
          ><feather-icon class="rounded-lg" icon="CheckIcon"
        /></b-badge>
        <b-badge v-else variant="light-danger" class="ml-25"
          ><feather-icon class="rounded-lg" icon="XIcon"
        /></b-badge>
      </template>
      <template #is_active="{ data }">
        <b-badge
          variant="light-success"
          class="ml-25"
          v-if="data.item.is_active"
          ><feather-icon class="rounded-lg" icon="CheckIcon"
        /></b-badge>
        <b-badge v-else variant="light-danger" class="ml-25"
          ><feather-icon class="rounded-lg" icon="XIcon"
        /></b-badge>
      </template>
      <template #is_system="{ data }">
        <b-badge
          variant="light-success"
          class="ml-25"
          v-if="data.item.is_system"
          ><feather-icon class="rounded-lg" icon="CheckIcon"
        /></b-badge>
        <b-badge v-else variant="light-danger" class="ml-25"
          ><feather-icon class="rounded-lg" icon="XIcon"
        /></b-badge>
      </template>
      <template #notifiable_id="{ data }">
        <span>
          {{ data.item.notifiable_id || "-" }}
        </span>
      </template>
      <template #notifiable_type="{ data }">
        <span>
          {{
            notificationTypes.find((x) => x.value === data.item.type) &&
            notificationTypes.find((x) => x.value === data.item.type).label
          }}
        </span>
      </template>
      <template #operator="{ data }">
        <span>
          {{
            data.item.operator == "AFTER"
              ? "بعد"
              : data.item.operator == "BEFORE"
              ? "بعد"
              : "-"
          }}
        </span>
      </template>
      <template #sms="{ data }">
        <b-badge variant="light-success" class="ml-25" v-if="data.item.sms"
          ><feather-icon class="rounded-lg" icon="CheckIcon"
        /></b-badge>
        <b-badge v-else variant="light-danger" class="ml-25"
          ><feather-icon class="rounded-lg" icon="XIcon"
        /></b-badge>
      </template>

      <template #time="{ data }">
        <span>
          {{ data.item.time || "-" }}
        </span>
      </template>

      <!-- <template #variable="{ data }">
        <span>
        {{ data.item.variable || "-" }}
        </span>
      </template> -->
      <template #actions="{ data }">
        <b-button
          size="sm"
          variant="flat-warning"
          :to="{
            name: 'notification-edit',
            params: {
              id: data.item.id,
            },
          }"
          style="white-space: nowrap"
        >
          <feather-icon icon="EditIcon" />
          <span class="ml-50">ویرایش</span>
        </b-button>
        <b-button
          size="sm"
          variant="flat-danger"
          @click="removeNotification(data.item)"
          style="white-space: nowrap"
        >
          <feather-icon icon="TrashIcon" />
          <span class="ml-50">حذف</span>
        </b-button>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormInput,
  BForm,
  BFormGroup,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import DataTable from "@/@core/components/data-table/DataTable.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import vSelect from "vue-select";
import qs from "qs";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormInput,
    BForm,
    BFormGroup,
    SelectBox,
    vSelect,
  },
  data() {
    return {
      choosenPage: 1,
      Notifications: [],
      currentPage: 1,
      pagination: {},
      loading: false,
      search: "",

      fields: [
        { key: "admin_notify", label: "پیام به ادمین" },
        { key: "user_notify", label: "پیام به کاربر" },
        { key: "subject", label: "موضوع" },
        { key: "email", label: "ایمیل" },
        { key: "sms", label: "پیامک" },
        { key: "is_active", label: "فعال" },
        // { key: "is_system", label: "is system" },
        // { key: "notifiable_id", label: "notifiable id" },
        { key: "notifiable_type", label: "نوع پیام" },
        { key: "operator", label: "اپراتور" },
        { key: "time", label: "زمان(روز)" },
        // { key: "variable", label: "variable" },
        { key: "actions", label: "عملیات" },
      ],
      notificationType: "",
      notificationStatus: "",
      searchBy: "",
      searchByType: [
        {
          label: "موضوع ",
          value: "subject",
        },
        {
          label: "پیام به کاربر ",
          value: "user_notify",
        },
        {
          label: "پیام به ادمین ",
          value: "admin_notify",
        },
      ],
      notificationStatuses: [
        {
          label: "فعال ",
          value: "active",
        },
        {
          label: "غیر فعال ",
          value: "deActive",
        },
      ],
      notificationTypes: [
        {
          label: "شروع تمرین",
          value: "StartExercise",
        },
        {
          label: "پایان تمرین",
          value: "EndExercise",
        },
        {
          label: "ددلاین تمرین",
          value: "DeadlineExercise",
        },
        {
          label: "شروع دوره",
          value: "StartCourse",
        },
        {
          label: "پایان دوره",
          value: "EndCourse",
        },
        {
          label: "ثبت نام در دوره",
          value: "RegisterInCourse",
        },
        {
          label: "دوره فعال ",
          value: "ActiveCourse",
        },
        {
          label: "خرید دوره",
          value: "BuyCourse",
        },
        {
          label: "پرداخت جریمه",
          value: "PayPenalty",
        },
        {
          label: "شروع ترم",
          value: "StartSemester",
        },
        {
          label: "پایان ترم",
          value: "EndSemester",
        },
        {
          label: "ثبت نام در ترم",
          value: "RegisterInSemester",
        },
        {
          label: "ترم فعال",
          value: "ActiveSemester",
        },
        {
          label: "خرید ترم",
          value: "BuySemester",
        },
        {
          label: "ایجاد جلسه ",
          value: "AddSession",
        },
        {
          label: "مشاهده جلسه ",
          value: "SeenSession",
        },
        {
          label: "ایجاد جریمه",
          value: "CreatePenalty",
        },
      ],
    };
  },
  computed: {
    selectedItem() {
      return {
        notificationType: this.notificationType,
        notificationStatus: this.notificationStatus,
      };
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.getNotifications();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "notifications",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val) {
        let route = this.$route.query.filters;
        let filters = {};
        (route.is_active || route.is_active == 0) &&
          (filters.is_active = route.is_active);
        route.type && (filters.type = route.type);
        this.$router.push({
          name: "notifications",
          query: {
            filters,
          },
        });
      }
    },
    searchBy(val) {
      this.search = "";
    },
    selectedItem(val) {
      let filters = {
        ...this.$route.query.filters,
      };
      val.notificationType && val.notificationType.value
        ? (filters.type = val.notificationType.value)
        : filters.type
        ? delete filters.type
        : "";
      val.notificationStatus
        ? val.notificationStatus.value == "active"
          ? (filters.is_active = 1)
          : val.notificationStatus.value == "deActive"
          ? (filters.is_active = 0)
          : ""
        : filters.is_active
        ? delete filters.is_active
        : "";

      this.$router.push({
        name: "notifications",
        query: {
          ...this.$route.query,
          filters,
        },
      });
    },
  },
  created() {
    if (this.$route.query.filters || this.$route.query.key) {
      this.$router.push({
        name: "notifications",
      });
    }
  },
  methods: {
    removeNotification(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این پیام حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/system-notifications/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeCoursesData = [];
                await this.getNotifications();
              } else {
                await this.$router.push({
                  name: "notifications",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "پیام با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمده است",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    async onSearch() {
      if (this.search) {
        let filters = {
          ...this.$route.query.filters,
        };

        this.searchBy == "subject"
          ? (filters.subject = this.search)
          : this.searchBy == "user_notify"
          ? (filters.user_notify = this.search)
          : this.searchBy == "admin_notify"
          ? (filters.admin_notify = this.search)
          : "";

        this.$router.push({
          name: "notifications",
          query: {
            ...this.$route.query,
            filters,
          },
        });
      }
    },
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async getNotifications() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get("/panel/system-notifications", {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.Notifications = data.data.system_notifications;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>
